module.exports = __webpack_public_path__ + "assets/b911c6e5d76b232e37fca13a7c8ac24d.mp3";